var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[((_vm.$route.name) + "-route")],attrs:{"id":"app"}},[_c('SkipLink'),_vm._v(" "),_c('Nuxt'),_vm._v(" "),_c('MobileBottomNavigation'),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }